export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-bing-7ceabff397557265a49c0e60b3cfb76d.svg";